import { render, staticRenderFns } from "./journalEntryInfoModal.vue?vue&type=template&id=494a168d&scoped=true&"
import script from "./journalEntryInfoModal.vue?vue&type=script&lang=js&"
export * from "./journalEntryInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./journalEntryInfoModal.vue?vue&type=style&index=0&id=494a168d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494a168d",
  null
  
)

export default component.exports